var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('about-us-component'),_c('products-component'),_c('news-component'),_c('recruitment-component'),_c('partners-component')],1)}
var staticRenderFns = []

export { render, staticRenderFns }